// extracted by mini-css-extract-plugin
export default {"list":"search-checkboxes-module--list--kxYUP"};